var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/TitleActionBar.tsx";
import React from 'react';
import { HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack } from '@adc/parallax-icons';
import { IconButton } from 'Components/utility';
import mediator from 'Utilities/mediator';
import { ActionBarHeader } from './ActionBarHeader';
const TitleActionBar = ({
  titleTestID: testIDTitle,
  actionButtonTestID: testIDActionButton,
  title,
  onBack
}) => {
  return /*#__PURE__*/React.createElement(VStack, {
    style: {
      top: 0,
      left: 0,
      right: 0
    },
    backgroundColor: "$surface.container",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ActionBarHeader, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(HStack, {
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    testID: testIDActionButton,
    onPress: () => {
      onBack ? onBack() : mediator.publish('router:back');
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconBack, {
    testID: `${testIDActionButton}-icon`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Text, {
    testID: testIDTitle,
    color: "$text.100",
    fontSize: "$h4.strong",
    fontWeight: "$h4.strong",
    width: "100%",
    alignSelf: "center",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, title)));
};
export { TitleActionBar };